// @ts-nocheck
import { Model } from 'backbone';
import Utils from 'views/store/common/utility';

export class ProjectChecklistItemModel extends Model {
	static new(attributes = {}, options = {}) {
		const _instance = new ProjectChecklistItemModel();
		_instance.onFetch(attributes, options);
		return _instance;
	}

	defaults() {
		return {
			id: null,
			prefix: null,
			path: null
		};
	}

	hasClass() {
		return Utils.defined(this.get('checklistClass')) && this.get('checklistClass').checklistClass !== '';
	}

	openUrl() {
		window.open(this.get('path'), '_new');
		return this;
	}

	onFetch(response = {}, options = {}) {
		this.set(response, options);
	}
}
